// SidebarNav.js
import Sidebar from "../sidebar";
import { useState, useEffect } from "react";
import designicons from "../../devdata/assets";

import { faLightbulb, faMessage } from "@fortawesome/free-regular-svg-icons";
const menuItemsTop = [
  {
    label: "Dashboard",
    path: "/Dashboard",
    icon: designicons._HomeIcon_,
  },
  // {
  //   label: "Strategy Console",
  //   path: "/StrategyConsole",
  //   icon: designicons._LightbulbIcon_,
  // },
  {
    label: "Sector Pulse",
    path: "/Sector",
    icon: designicons._SuitcaseIcon_,
  },
  {
    label: "Pi Scanner",
    path: "/PiScanner",
    icon: designicons.Pi,
  },
  {
    label: "Sector Momentum",
    path: "/Intraday",
    icon: designicons.Cash,
  },
  {
    label: "My Watchlist",
    path: "/Myday",
    icon: designicons._HighlightsIcon_,
  },
  {
    label: "My Profile",
    path: "/Profile",
    icon: designicons._PersonCircleIcon_,
  },
  {
    label: "Trade Journal",
    path: "/Journal",
    icon: designicons.BookIcon,
  },
  {
    label: "Learn",
    path: "/Learn",
    icon: designicons.BacklogIcon,
  },
];

const menuItemsBottom = [
  {
    label: "Support",
    path: "/Help",
    icon: designicons._QuestionsIcon_,
  },
  {
    label: "FAQ",
    path: "/FAQ",
    icon: designicons._DialOutIcon_,
  },
  ...(process.env.NODE_ENV === "development"
    ? [
      {
        label: "Test",
        path: "/test",
        icon: designicons._ChevronRightCircleIcon_,
      },
    ]
    : []),
];

function SidebarNav({
  isCollapsed = false,
  setCollapsed,
  isMobileView,
  isMobileMenuOpen,
  setIsMobileMenuOpen,
  sidebarRef, // Receive sidebarRef prop
}) {
  const handleMenuItemClick = (label) => {
    // console.log(`Clicked on: ${label}`);
    setIsMobileMenuOpen(false);
  };

  const [isMobileViewLocal, setIsMobileViewLocal] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileViewLocal(window.innerWidth < 1024); // Increased breakpoint to 1024px here too, though not strictly necessary as prop is passed
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex justify-start items-start ">
      <Sidebar
        menuItemsTop={menuItemsTop}
        menuItemsBottom={menuItemsBottom}
        onMenuItemClick={handleMenuItemClick}
        isCollapsed={isCollapsed}
        onChange={setCollapsed}
        isMobileView={isMobileView}
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        sidebarRef={sidebarRef} // Pass sidebarRef to Sidebar
      />
    </div>
  );
}

export default SidebarNav;
